import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InformationComponent } from './information/information.component';
import { MatSliderModule } from '@angular/material/slider';
import { MatMenuModule  } from '@angular/material/menu';
import { MatIconModule  } from '@angular/material/icon';
import {MatTabsModule} from "@angular/material/tabs";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatListModule} from "@angular/material/list";
import {MatCheckboxModule } from "@angular/material/checkbox";
import {MatCardModule} from "@angular/material/card";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule} from '@angular/material/form-field';
import {MatToolbarModule} from "@angular/material/toolbar";
import { AppRoutingModule } from './app-routing.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import { ModbuslistComponent } from './modbus/modbuslister/modbuslist.component';
import { ModbusdetailsComponent } from './modbus/modbusdetails/modbusdetails.component';
import { DigitalinlistComponent } from './digitalin/digitalinlist/digitalinlist.component';
import { DigitalindetailsComponent } from './digitalin/digitalindetails/digitalindetails.component';
import { DigitaloutlistComponent } from './digitalout/digtaloutlist/digitaloutlist.component';
import { DigitaloutdetailsComponent } from './digitalout/digitaloutdetails/digitaloutdetails.component';
import { AnalogoutlistComponent } from './analogout/analogoutlist/analogoutlist.component';
import { AnalogoutdetailsComponent } from './analogout/analogoutdetails/analogoutdetails.component';
import {MatProgressBarModule} from "@angular/material/progress-bar";
import { FrequencylistComponent } from './frequency/frequencylist/frequencylist.component';
import { FrequencydetailsComponent } from './frequency/frequencydetails/frequencydetails.component';
import { CounterdetailsComponent } from './counter/counterdetails/counterdetails.component';
import { CounterlistComponent } from './counter/counterlist/counterlist.component';
import { AnalyserComponent } from './analyser/analyser/analyser.component';
import { MappedservolisterComponent } from './mappedservo/mappedservolister/mappedservolister.component';
import { MappedservodetailsComponent } from './mappedservo/mappedservodetails/mappedservodetails.component';
import { DmesglogComponent } from './dmesglog/dmesglog/dmesglog.component';
import { ClimatelogComponent } from './climatelog/climatelog/climatelog.component';
import {MatExpansionModule} from "@angular/material/expansion";
import { QueueComponent } from './queue/queue/queue.component';
import { MeasurementSlotListComponent } from './measurementsslots/measurementslot-list/measurement-slot-list.component';
import { MeasurementSlotDetailsComponent } from './measurementsslots/measurementslot-details/measurement-slot-details.component';
import { AnaloginlistComponent } from './analogin/analoginlist/analoginlist.component';
import { AnalogindetailsComponent } from './analogin/analogindetails/analogindetails.component';
import { CalibrationComponent } from './calibration/calibration/calibration.component';
import { ListclientsComponent } from './listclients/listclients/listclients.component';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import {ExcelModule, GridModule, PDFModule} from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { MenuComponent } from './menu/menu.component';
import { MenuModule } from '@progress/kendo-angular-menu';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import {AuthInterceptor} from "./AuthInterceptor";
import { ConnectionComponent } from './connection/connection.component';
import { AuthModule } from '@auth0/auth0-angular';
import { AuthButtonComponent } from './auth/auth-button/auth-button.component';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { UserprofileComponent } from './userprofile/userprofile.component';
import { WifiMenuDataComponent } from './wifi-menu-data/wifi-menu-data.component';
import { InformationNetworkComponent } from './information/information-network/information-network.component';
import { InformationNawComponent } from './information/information-naw/information-naw.component';
import { InformationProgramComponent } from './information/information-program/information-program.component';
import { InformationFusesComponent } from './information/information-fuses/information-fuses.component';
import { InformationFastlinkComponent } from './information/information-fastlink/information-fastlink.component';
import { InformationRackxtenderComponent } from './information/information-rackxtender/information-rackxtender.component';
import { InformationLinuxComponent } from './information/information-linux/information-linux.component';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { MeasurementListComponent } from './measurements/measurement-list/measurement-list.component';
import { MeasurementItemComponent } from './measurements/measurement-item/measurement-item.component';
import { MeasurementItemDetailsComponent } from './measurements/measurement-item-details/measurement-item-details.component';
import { MeasurementGaugeComponent } from './measurements/measurement-gauge/measurement-gauge.component';
import { ChartsModule } from '@progress/kendo-angular-charts';
import 'hammerjs';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AppversionComponent } from './appversion/appversion.component';
import { LoaderComponent } from './loader/loader.component';
import {LabelModule} from "@progress/kendo-angular-label";
import { TrendComponent } from './trend/trend.component';
import { CardComputerOverviewComponent } from './cards/card-computer-overview/card-computer-overview.component';
import { CardDepartmentComponent } from './cards/card-department/card-department.component';
import { CardGaugeComponent } from './cards/card-gauge/card-gauge.component';
import { CardGraphLineComponent } from './cards/card-graph-line/card-graph-line.component';
import { LineComponent } from './cards/line/line.component'
import {LineButtonComponent} from "./cards/line/line-button/line-button.component";
import {LineMeasurementComponent} from "./cards/line/line-measurement/line-measurement.component";
import {LineSettingComponent} from "./cards/line/line-setting/line-setting.component";
import {LineSettingTextComponent} from "./cards/line/line-setting-text/line-setting-text.component";
import {LineStatusComponent} from "./cards/line/line-status/line-status.component";
import {IconComponent} from "./climatehelpers/units/icon/icon.component";
import {UnitComponent} from "./climatehelpers/units/unit/unit.component";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {StatusSymbolComponent} from "./climatehelpers/status-symbol/status-symbol.component";
import { ComplexDevicesListComponent } from './complex-devices/complex-devices-list/complex-devices-list.component';
import { ComplexDevicesDetailsComponent } from './complex-devices/complex-devices-details/complex-devices-details.component';
import { CPXDEV_EVHI_HPComponent } from './complex-devices/cpxdev-evhi-hp/cpxdev-evhi-hp.component';
import { CPXDEVTESTERComponent } from './complex-devices/cpxdev-tester/cpxdev-tester.component';
import { BranchTypeMathValveComponent } from './cards/branch_views/branch-type-math-valve/branch-type-math-valve.component';
import { BranchTypeOutSideOverviewComponent } from './cards/branch_views/branch-type-out-side-overview/branch-type-out-side-overview.component';
import { FastlinkmonitorComponent } from './fastlinkmonitor/fastlinkmonitor/fastlinkmonitor.component';
import { FastLinkVeldStationComponent } from './fastlinkmonitor/fast-link-veld-station/fast-link-veld-station.component';
import { FastLinkFastLinkComponent } from './fastlinkmonitor/fast-link-fast-link/fast-link-fast-link.component';
import { FastLinkFarLinkComponent } from './fastlinkmonitor/fast-link-far-link/fast-link-far-link.component';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { FastLinkBluePrintUpdaterComponent } from './fastlinkmonitor/fast-link-blue-print-updater/fast-link-blue-print-updater.component';
import { FastLinkLCDComponent } from './fastlinkmonitor/fast-link-lcd/fast-link-lcd.component';
import { BranchTypeFurtiValveComponentComponent } from './cards/branch_views/branch-type-furti-valve-component/branch-type-furti-valve-component.component';
import { BranchTypeSingleValveSummaryComponent } from './cards/branch_views/branch-type-single-valve-summary/branch-type-single-valve-summary.component';
import { BranchTypeZoneOverviewComponent } from './cards/branch_views/branch-type-zone-overview/branch-type-zone-overview.component';
import { BranchTypeDaySupplyOverviewComponent } from './cards/branch_views/branch-type-day-supply-overview/branch-type-day-supply-overview.component';
import { BranchTypeUnitOverviewComponent } from './cards/branch_views/branch-type-unit-overview/branch-type-unit-overview.component';
import { BranchTypeAfarmOverviewComponent } from './cards/branch_views/branch-type-afarm-overview/branch-type-afarm-overview.component';
import { BranchGaugeSettingMeasurementComponent } from './cards/branch_devices/branch-gauge-setting-measurement/branch-gauge-setting-measurement.component';
import { BranchGaugeMeasurementComponent } from './cards/branch_devices/branch-gauge-measurement/branch-gauge-measurement.component';
import { BranchFanComponent } from './cards/branch_devices/branch-fan/branch-fan.component';
import { IrrigationValveComponent } from './cards/custom_views/irrigation-valve/irrigation-valve.component';
import { IrrigationValveCardLinkComponent } from './cards/custom_views/irrigation-valve-card-link/irrigation-valve-card-link.component';
import { CPXDEV_EVHI_LPComponent } from './complex-devices/cpxdevevhi-lp/cpxdevevhi-lp.component';
import { HeatmapComponent } from './cards/heatmap/heatmap.component';
import { ModbusnetworkdetailsComponent } from './modbus/modbusnetworkdetails/modbusnetworkdetails.component';
import { ClientsComponent } from './clients/clients.component';
import { FilterModule } from '@progress/kendo-angular-filter';






@NgModule({
  declarations: [
    AppComponent,
    InformationComponent,
    ModbuslistComponent,
    ModbusdetailsComponent,
    DigitalinlistComponent,
    DigitalindetailsComponent,
    DigitaloutlistComponent,
    DigitaloutdetailsComponent,
    AnalogoutlistComponent,
    AnalogoutdetailsComponent,
    FrequencylistComponent,
    FrequencydetailsComponent,
    CounterdetailsComponent,
    CounterlistComponent,
    AnalyserComponent,
    MappedservolisterComponent,
    MappedservodetailsComponent,
    DmesglogComponent,
    ClimatelogComponent,
    QueueComponent,
    MeasurementSlotListComponent,
    MeasurementSlotDetailsComponent,
    AnaloginlistComponent,
    AnalogindetailsComponent,
    CalibrationComponent,
    ListclientsComponent,
    MenuComponent,
    ConnectionComponent,
    AuthButtonComponent,
    UserprofileComponent,
    WifiMenuDataComponent,
    InformationNetworkComponent,
    InformationNawComponent,
    InformationProgramComponent,
    InformationFusesComponent,
    InformationFastlinkComponent,
    InformationRackxtenderComponent,
    InformationLinuxComponent,
    MeasurementListComponent,
    MeasurementItemComponent,
    MeasurementItemDetailsComponent,
    MeasurementGaugeComponent,
    AppversionComponent,
    LoaderComponent,
    TrendComponent,
    CardComputerOverviewComponent,
    CardDepartmentComponent,
    CardGaugeComponent,
    CardGraphLineComponent,
    LineComponent,
    LineSettingComponent,
    LineButtonComponent,
    LineMeasurementComponent,
    LineSettingTextComponent,
    LineStatusComponent,
    IconComponent,
    UnitComponent,
    StatusSymbolComponent,
    ComplexDevicesListComponent,
    ComplexDevicesDetailsComponent,
    CPXDEV_EVHI_HPComponent,
    CPXDEVTESTERComponent,
    BranchTypeMathValveComponent,
    BranchTypeOutSideOverviewComponent,
    FastlinkmonitorComponent,
    FastLinkVeldStationComponent,
    FastLinkFastLinkComponent,
    FastLinkFarLinkComponent,
    FastLinkBluePrintUpdaterComponent,
    FastLinkLCDComponent,
    BranchTypeFurtiValveComponentComponent,
    BranchTypeSingleValveSummaryComponent,
    BranchTypeZoneOverviewComponent,
    BranchTypeDaySupplyOverviewComponent,
    BranchTypeUnitOverviewComponent,
    BranchTypeAfarmOverviewComponent,
    BranchGaugeSettingMeasurementComponent,
    BranchGaugeMeasurementComponent,
    BranchFanComponent,
    IrrigationValveComponent,
    IrrigationValveCardLinkComponent,
    CPXDEV_EVHI_LPComponent,
    HeatmapComponent,
    ModbusnetworkdetailsComponent,
    ClientsComponent

  ],
  imports: [
    MatSliderModule,
    MatMenuModule,
    MatIconModule,
    MatTabsModule,
    MatGridListModule,
    MatListModule,
    MatCheckboxModule,
    MatCardModule,
    MatProgressSpinnerModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    AppRoutingModule,
    HttpClientModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatExpansionModule,
    GaugesModule,
    LayoutModule,
    ButtonsModule,
    GridModule,
    InputsModule,
    IconsModule,
    IndicatorsModule,
    MenuModule,
    NavigationModule,

    AuthModule.forRoot({
      domain: 'dev-vortex.eu.auth0.com',
      clientId: 'AaWemoXZdHBdUfeCzGS9LnyvCkuXqGSX'
      // Sercom WebApplications
    }),

    ToolBarModule,
    PopupModule,
    DialogsModule,
    ChartsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    LabelModule,
    FontAwesomeModule,
    NotificationModule,
    PDFModule,
    ExcelModule,
    FilterModule

  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
    { provide: HTTP_INTERCEPTORS,              useClass: AuthInterceptor,        multi: true   },


  ]
})
export class AppModule { }
